import { Box, Image, Link } from '@opendoor/bricks-next';

import type { IBNComponentThemeConfig } from '../styles/ComponentTheme';
import { FooterForegroundBox } from './Footer';

const FooterAppDownload = ({
  theme,
  appleStoreLink,
  appleStoreImageUrl,
  googlePlaystoreLink,
  googlePlayStoreImageUrl,
  locale,
}: {
  theme: IBNComponentThemeConfig;
  appleStoreLink?: string;
  appleStoreImageUrl: string;
  googlePlaystoreLink?: string;
  googlePlayStoreImageUrl: string;
  locale?: string;
}) => (
  <FooterForegroundBox theme={theme} title="Get the app" isAppButtonFooter={true}>
    <Box
      flexWrap="wrap"
      flexDirection="row"
      alignItems="center"
      justifyContent="center"
      gap="$2"
      $largerThanSM={{ justifyContent: 'flex-end' }}
    >
      <Link
        href={appleStoreLink}
        aria-label="Opendoor Applestore button"
        hoverStyle={{ color: theme.contentPrimary }}
        color={theme.contentPrimary}
        analyticsName="cosmos-landing-page-v2-footer-applesotre-button"
      >
        <Image
          source={{ uri: appleStoreImageUrl }}
          alt="Opendoor Applestore"
          width={135}
          height={45}
        />
      </Link>
      <Link
        href={googlePlaystoreLink}
        aria-label="Opendoor Google play button"
        hoverStyle={{ color: theme.contentPrimary }}
        color={theme.contentPrimary}
        analyticsName="cosmos-landing-page-v2-footer-googlgplay-button"
      >
        <Image
          source={{ uri: googlePlayStoreImageUrl }}
          alt="Opendoor Google Play"
          width={locale === 'es' ? 150 : 135}
          height={45}
        />
      </Link>
    </Box>
  </FooterForegroundBox>
);

export default FooterAppDownload;
